(function () {
'use strict';

angular
    .module('searchRoutes', [
        'searchControllers',
        'services.historyCtxt'
    ])
    .config(router);

router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

function router($stateProvider, historyCtxtServiceProvider) {

    $stateProvider.state('search', {
        url: '/Search?q&h&r',
        params: {
            h: { array: true },
            r: { array: true }
        },
        reloadOnSearch: false,
        controller: 'SearchController',
        templateUrl: require('./search.tpl.html')
    });

    historyCtxtServiceProvider.setCtxtState('search',
        '/app/Main/search/GOVHistoryCtxtDirective-searchResults.tpl.html'
    );
}
})();